import { render, staticRenderFns } from "./Upper.vue?vue&type=template&id=535c85f0"
import script from "./Upper.vue?vue&type=script&lang=js"
export * from "./Upper.vue?vue&type=script&lang=js"
import style0 from "./Upper.vue?vue&type=style&index=0&id=535c85f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports